import _ from 'lodash'
import {DeepPartial, FieldPathValue} from 'react-hook-form'

import {isDateTimeDirty} from '../../fields/dateTime/isDateTimeDirty'
import {isContractDirty, isMaterialDirty} from '../../fields/mix/isMaterialDirty'
import {isMaterialVariationDirty} from '../../fields/mix/isMaterialVariationDirty'
import {FieldNames, FieldsForm, FieldValue} from '../../fields/types'
import {normalizeFieldName} from '../../fields/utils/fieldNames.utils'

export const isFieldDirty = <T extends FieldNames>(
  fieldName: T,
  fieldValue: FieldValue<T>,
  defaultValue?: DeepPartial<FieldValue<T>>
) => {
  if (!defaultValue && !fieldValue) {
    return false
  }

  const {field, fieldPart} = normalizeFieldName(fieldName)

  if (field === 'dateTime') {
    return isDateTimeDirty(
      fieldPart,
      fieldValue as FieldPathValue<FieldsForm, 'dateTime'>,
      defaultValue as FieldPathValue<FieldsForm, 'dateTime'>
    )
  }

  if (field === 'material') {
    return isMaterialDirty(
      fieldValue as FieldPathValue<FieldsForm, 'material'>,
      defaultValue as FieldPathValue<FieldsForm, 'material'>
    )
  }

  if (field === 'contract') {
    return isContractDirty(
      fieldValue as FieldPathValue<FieldsForm, 'contract'>,
      defaultValue as FieldPathValue<FieldsForm, 'contract'>
    )
  }

  if (field === 'materialVariations') {
    return isMaterialVariationDirty(
      fieldValue as FieldPathValue<FieldsForm, 'materialVariations'>,
      defaultValue as FieldPathValue<FieldsForm, 'materialVariations'>
    )
  }

  return !_.isEqual(defaultValue, fieldValue)
}
